module.exports = __webpack_public_path__ + "common/icon-twitter-9955bfe39960864446277c4656ef8e83.svg";